import { render } from "./UserResultList.vue?vue&type=template&id=70086240"
import script from "./UserResultList.vue?vue&type=script&lang=js"
export * from "./UserResultList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__